export default __webpack_public_path__ + "static/media/corporate7.05d29540.webp";